import { createStore } from 'redux';
import pick from 'lodash/pick';

function restoreState(factory) {
  const savedState = localStorage.getItem(factory.namespace);
  localStorage.removeItem(factory.namespace);
  if (!savedState) return {};

  // Temporary code to safeguard against empty session objects
  // This can be removed in the future after localStorage data has stabilized
  // (e.g. after a few weeks or months)
  // See BSD-33121 for more information.
  const parsedState = JSON.parse(savedState);
  if (parsedState?.session && Object.keys(parsedState.session).length === 0) {
    const { session, ...stateWithoutSession } = parsedState || {};

    return stateWithoutSession;
  }

  return parsedState;
}

function saveState(factory, state) {
  localStorage.setItem(factory.namespace, JSON.stringify(state));
}

function newStore(reducer, state, middleware) {
  return createStore(reducer, state, middleware);
}

export default class LocalStoreFactory {
  constructor(namespace, options = {}) {
    this.namespace = namespace;
    this.options = options;
  }

  store(reducer, providedState, middleware) {
    const localState = restoreState(this);
    const initialState = { ...providedState, ...localState };

    const configuredStore = newStore(reducer, initialState, middleware);

    configuredStore.subscribe(() => {
      let stateToSave = configuredStore.getState();

      if (this.options.permit) {
        stateToSave = pick(stateToSave, this.options.permit);
      }

      saveState(this, stateToSave);
    });

    return configuredStore;
  }
}
